<script>

    import layer from "@/mixins/mapboxLayer";
     import {featureCollection} from '@turf/helpers'
   
   import circle from '@turf/circle'

   import lineDistance from '@turf/length'

    export default{
        
        mixins:[layer],
        
        name:"elevation",

        data(){
            return {
                sourceOptions:{buffer:0,tolerance:1},
            }
        },
        

        computed:{
            geoJSON:function(){
                // return false;
                if(!this.visible) return false;
                
                var geojson = this.$store.getters.currentCourseLeg
                if( !geojson)
                    geojson = this.$store.getters.courses;

                var points = this.terrainProfile(geojson);
                var geoGsonFinal = featureCollection(this.generate3dFeature(points))
                console.log(geoGsonFinal)
                return geoGsonFinal

            },
            visible:function(){
                return this.$store.state.altimetriaVisible
            },
        },

        watch:{
            geoJSON:function(){
                
                setTimeout( ()=>this.animateFeatures(2, false),0);
            }
        },

        methods:{

            terrainProfile:function(geoJSON){
                if(!geoJSON) return false;
                    var course = geoJSON;
                    var distance = lineDistance(course);
                    var points = [];

                    console.time("along points");
                    for (var i = 0; i < distance; i += 0.035) {
                        var point = _.along(course, i);
                        point.properties['distancia'] = i;
                        var slope = _.get(point, 'properties.slope');
                        point.properties['color'] = _.colorRamp(-7, 5, slope);
                        points.push(point);
                    }
                    console.timeEnd("along points");
                    return points
            },

            generate3dFeature:function(points3d){
                return _.map(points3d, point3d =>{
                    var feature3d = circle(point3d, 25, {units: 'meters',steps:6});
                    var z = _.get(point3d, 'geometry.coordinates');
                    z = _.fromToInterpolation(999,1110,1,500,z[2])
                    feature3d.properties['z_value'] =  z;
                    return feature3d;
                })
            }

        },

        style: function () {
            return {
                'type': 'fill-extrusion',
                'slot':'top',
                'paint': {
                    // See the Mapbox Style Specification for details on data expressions.
                    // https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions
        
                    // Get the fill-extrusion-color from the source 'color' property.
                    'fill-extrusion-color': ['get', 'color'],
        
                    // Get fill-extrusion-height from the source 'height' property.
                    'fill-extrusion-height': ['get', 'z_value'],
        
                    // Get fill-extrusion-base from the source 'base_height' property.
                    'fill-extrusion-base': 0,
        
                    // Make extrusions slightly opaque for see through indoor walls.
                    'fill-extrusion-opacity': 1
                }
            }
        }

    }


</script>